import { constantsData, formFieldNamesData } from "@/data";
import { FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    date,
    description,
} = constantsData.forms.dataSources.entry;

const {
    date: dateFieldName,
    description: descriptionFieldName,
} = formFieldNamesData;

export const dataSourceEntryFormData = [
    {
        description: date.description,
        label: date.label,
        name: dateFieldName,
        type: FieldTypeEnum.DATE_TIME,
    },
    {
        description: description.description,
        isOptional: true,
        label: description.label,
        name: descriptionFieldName,
        type: InputTypeEnum.TEXT,
    },
];
